module.exports = __webpack_public_path__ + "img/textless-logo.f59239e.svg";